import { PatientActivityRoute } from "route-components/PatientActivityRoute";
import { createFileRoute } from "@tanstack/react-router";
import { getPatientActivityDefaultSearch } from "utils/routeDefaults";

export interface PatientActivitySearchParams {
    patientName: string;
    status: ("unsent" | "outstanding" | "paid")[];
}

export type PatientActivitySearchParamsPartial = Partial<PatientActivitySearchParams>;

export const Route = createFileRoute("/history/patients")({
    component: PatientActivityRoute,
    validateSearch: getPatientActivityDefaultSearch,
});
